module.exports = __webpack_public_path__ + "img/build-to-rent-furnished-1.df930137.jpg";